module.exports = __webpack_public_path__ + "img/login-right-bg.cef9afdd.png";